export class ScholarshipResponses {
    Selected: boolean;
    ScholarshipID: number;
    ScholarshipName: string;
    ScholarshipDescription: string;
    AdditionalQuestion: string;
    AqHaveYesNo: boolean;
    AqYesRequired: boolean;
    AqHaveText: boolean;
    AdditionalQuestionTextResponse: string;
    AdditionalQuestionYesNoResponse: boolean;
    EmployeeNameLabel: string;
    EmployeeNameResponse: string;
    EmployeeLocationLabel: string;
    EmployeeLocationResponse: string;
    EmployeeSSNLabel: string;
    EmployeeSSNResponse: string;
    StoreLocationNumberLabel: string;
    StoreLocationNumberResponse: string;
    AccountNameLabel: string;
    AccountNameResponse: string;
    AccountNumberLabel: string;
    AccountNumberResponse: string;
    ParentNameLabel: string;
    ParentNameResponse: string;
    ParentSSNLabel: string;
    ParentSSNResponse: string;
    ParentOrganizationLabel: string;
    ParentOrganizationResponse: string;
    ParentDepartmentLabel: string;
    ParentDepartmentResponse: string;
    ScholarshipEssayLabel: string;
    ScholarshipEssayResponse: string;
    ScholarshipEssay2Label: string;
    ScholarshipEssay2Response: string;
}